const UserPermissionManagementPermissions = {
  // READ PERMS
  USER_PERMISSION_MANAGEMENT_READ: 'user_permission_management_read',

  USER_PERMISSION_MANAGEMENT_WRITE: 'user_permission_management_write',
};

export default UserPermissionManagementPermissions;
